const DATA_TEST_IDS = {
  fragmentsCompanyHeader: 'company__fragments_company-header',
  fragmentsModuleAddDialog: 'company__fragments_module-add-dialog',
  fragmentsUploadCompanyAvatarDialog:
    'company__fragments_upload-company-avatar-dialog',
} as const;

export default DATA_TEST_IDS;
